
import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseFormWidgetComponent } from '../../../shared/base-form.component';

@Component({
    selector: 'checkbox',
    template: `
<div [class]="'checkbox' + (klass ? ' ' + klass : '') + (disabled ? ' disable' : '')" widget
    (mouseover)="data.hover = true" (mouseout)="data.hover = false">

    <label *ngIf="side==='left'" class="label" [for]="name" (touchrelease)="toggle()">{{ label }}</label>
    <div class="box" [class.active]="model" [class.hover]="data.hover" (touchrelease)="toggle()">
        <input type="checkbox" [(ngModel)]="model" [name]="name">
        <div class="check"><ng-content></ng-content></div>
    </div>
    <label *ngIf="side!=='left'" class="label" [for]="name" (touchrelease)="toggle()">{{ label }}</label>
</div>`,
    styles: [`.checkbox{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.checkbox.disable{pointer-events:none}.checkbox.disable .box{opacity:.35}.checkbox.disable .label{opacity:.2}.box{position:relative;margin:.25em;height:1em;width:1em;min-width:1em;border-radius:2px;border:1px solid #ccc;cursor:pointer}.box .check{display:none}.box.hover{background-color:#ccc}.box.active{border-color:#2196f3;background-color:#2196f3}.box.active .check{display:initial}.box.active.hover>*{opacity:.5}input{opacity:0!important;pointer-events:none}.check{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);height:.9em;width:.9em;background-position:center;background-size:cover;background-repeat:no-repeat;background-image:url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjRkZGRkZGIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KICAgIDxwYXRoIGQ9Ik05IDE2LjJMNC44IDEybC0xLjQgMS40TDkgMTkgMjEgN2wtMS40LTEuNEw5IDE2LjJ6Ii8+Cjwvc3ZnPg==)}.label{padding:.25em;cursor:pointer}`],
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CheckboxComponent),
        multi: true
      }
    ]
})
export class CheckboxComponent extends BaseFormWidgetComponent<boolean> implements ControlValueAccessor {
    @Input() public label = '';
    @Input() public side = 'right';

    public toggle() {
        this.model = !this.model;
        this.modelChange.emit(this.model);
        this.change(this.model);
    }
}
